<template>
  <component
    :is="selectComponent"
    v-bind="$attrs"
    v-model="selectedValues"
    :items="options"
    item-text="label"
    item-value="value"
    @change="handleChange"
  >
    <template v-slot:prepend-item>
      <v-list-item @click="onSelectAll">
        <v-list-item-action>
          <v-icon v-if="!allSelected">mdi-checkbox-blank-outline</v-icon>
          <v-icon v-if="allSelected">mdi-check-box-multiple-outline</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ selectAllText }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-2"></v-divider>
    </template>
  </component>
</template>

<script>
import { VSelect, VCombobox } from 'vuetify/lib';
import { isEqual } from 'lodash';

export default {
  name: 'CommonDropdown',

  /**
   * Explicitly register the v-select and v-combobox components. This was necessary since they
   * are conditionally rendered and it appears that the parser doesn't automatically register them
   */
  components: {
    VSelect,
    VCombobox
  },

  props: {
    options: {
      type: Array,
      required: true
    },
    /**
     * A set of selected options provided by the parent component allowing the parent to change/override
     * the selected state within this component
     */
    selectedOptions: {
      type: Array,
      default: () => []
    },
    /**
     * Optional boolean that drives whether or not to display the Select All option in the dropdown
     * menu (Defaults to false)
     */
    selectAll: {
      type: Boolean,
      default: () => false
    },
    /**
     * Optional boolean that drives whether to render a select or a combobox component
     */
    isCombobox: {
      type: Boolean,
      default: () => false
    }
  },

  data() {
    return {
      // Initialize to the parent provided selected values
      selectedValues: [...this.selectedOptions],
      selectComponent: this.isCombobox ? 'v-combobox' : 'v-select'
    };
  },

  computed: {
    allSelected() {
      return this.options.length === this.selectedValues.length;
    },

    selectAllText() {
      return this.allSelected ? 'Deselect All' : 'Select All';
    }
  },

  watch: {
    /**
     * Keep the local selectedValues in sync with the parent provided selectedOptions to allow
     * the parent to programmatically change the selected values
     */
    selectedOptions() {
      if (!isEqual(this.selectValues, this.selectedOptions)) {
        this.selectedValues = this.selectedOptions;
      }
    }
  },

  methods: {
    onSelectAll() {
      if (this.allSelected) {
        this.selectedValues = [];
      } else {
        this.selectedValues = this.options.map(({ value }) => value);
      }
    },

    handleChange() {
      this.$emit('change', this.selectedValues);
    }
  }
};
</script>
